<template>
  <div class="px-3 py-2">
    <v-form ref="forcar" lazy-validation>
      <b-sidebar
        id="open_messages"
        aria-labelledby="sidebar-no-header-title"
        no-header
        backdrop
        width="700px"
        style="direction: ltr"
        right
        title="إضافة ملاحظة"
        shadow
      >
        <template #default="{ hide }">
          <div class="m-1 text-start" style="direction: rtl">
            <div
              style="
                width: 120px;
                margin-right: 10px;
                background: #000;
                color: #fff;
                border-radius: 5px;
              "
              class="btn-primary btn-sm text-center"
            >
              <span>مراسلة </span>
            </div>
            <div
              @click="hide"
              id="hideaddConverts"
              style="
                width: 100px;
                text-align: center;
                float: left;
                margin-left: 5px;
                margin-top: -25px;
                cursor: pointer;
              "
              class="btn-danger btn-sm"
            >
              <span>{{ lang.close }}</span>
            </div>
          </div>
          <v-divider></v-divider>
          <v-row style="direction: rtl" class="m-2">
            <v-col cols="12" md="6" sm="12">
              <label>نوع الرسالة</label>
              <b-input-group>
                <b-form-select
                  class="selborder"
                  v-model="msg_type"
                  :options="msgTypes"
                ></b-form-select>
                <b-input-group-append style="margin-right: -20px; margin-top: 5px">
                  <i class="fas fa-arrow-down"></i>
                </b-input-group-append>
              </b-input-group>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <label>الاجراء</label>
              <b-input-group>
                <b-form-select
                  class="selborder"
                  v-model="msg_action"
                  :options="msgActions"
                ></b-form-select>
                <b-input-group-append style="margin-right: -20px; margin-top: 5px">
                  <i class="fas fa-arrow-down"></i>
                </b-input-group-append>
              </b-input-group>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <label>نص الرسالة</label>
              <b-form-textarea
                class="inborder"
                v-model="message_text"
                value=""
                required
              ></b-form-textarea>
            </v-col>
          </v-row>
        </template>
        <template #footer="">
          <div class="d-flex text-light align-items-center px-3 py-2">
            <b-button
              type="button"
              @click="addTasks()"
              variant="success"
              class="ma-2"
              style="width: 100px"
              >إضافة</b-button
            >
          </div>
        </template>
      </b-sidebar>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import { SnotifyPosition } from "vue-snotify";
export default {
  data() {
    return {
      customerid: 0,
      message_text: "<div style='padding:10px;text-align:center;'>ضع رسالتك هنا</div>",
      msg_type: 1,
      msg_action: 1,
      optionsS: [],
      product: 1,
    };
  },
  computed: {
    lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
    msgTypes: function()
    {
        let t = [
            {text: 'رسالة عادية', value: 1},
            {text: 'رسالة تنبيه', value: 2},
            {text: 'ايقاف مؤقت لعدم السداد', value: 3},
            {text: 'اصدار جديد', value: 4},
        ];

        return t;
    },
    msgActions: function()
    {
        let t = [
            {text: 'بدون اجراء', value: 1},
            {text: 'ايقاف النظام', value: 2},
            {text: 'ارجاع النظام', value: 3}
        ];

        return t;
    },
    getProds: function () {
      let t = [];
      for (let i = 0; i < this.optionsS.length; i++) {
        t.push({
          text: this.optionsS[i].name_ar,
          value: this.optionsS[i].value,
        });
      }
      return t;
    },
  },
  methods: {
    addTasks() {
      if (this.message_text == "") {

        let message = "يرجى اضافة نص للرسالة لا يمكن المتابعه بدون ";
        this.$snotify.error(message, "تنبيه", {
          timeout: 1000000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          position: SnotifyPosition.centerCenter,
          buttons: [
            {
              text: this.lang.close,
              action: (toast) => {
                this.$snotify.remove(toast.id);
              },
            },
          ],
        });
        return false;
      }
      const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
      post.append("type", "addMessageToCus");
      post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
      post.append("data[customerid]", this.customerid);
      post.append("data[message_text]", this.message_text);
      post.append("data[msg_action]", this.msg_action);
      post.append("data[msg_type]", this.msg_type);
      axios.post(this.$SAMCOTEC.r_path, post).then((response) => {
        if (response && response.data) {
          document.getElementById("hideaddConverts").click();
          let message = "تم اضافة الرسالة بنجاح";
          this.$snotify.error(message, "تنبيه", {
            timeout: 1000000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            position: SnotifyPosition.centerCenter,
            buttons: [
              {
                text: this.lang.close,
                action: (toast) => {
                  this.$snotify.remove(toast.id);
                },
              },
            ],
          });
        }
      });
    },
    getStatic() {
      const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
      post.append("type", "getStaticOptions");
      post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
      post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
      post.append("data[phrase]", "convertProducts");
      axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
        // // console.log("i am here",response.data)
        this.optionsS = response.data.results.data;
        // // console.log("i am here",this.optionsS);
      });
    },
  },
  created() {
    // this.getCurrent();
    // this.getStatus('taskStatus');
    this.getStatic("convertProducts");
  },
};
</script>
